import BaseViewController from "./base-view-controller";
import {
  buildPharmacyViewString,
  buildPharmacyStatusMessage
} from "./helpers/pharmacy";
import { getFlow } from "../api/flow";
import pharmacyValidation from "./helpers/pharmacy-validation";

const buildPharmacies = (pharmacies, action) => {
  /* eslint-disable new-cap */
  return pharmacies.map(pharmacy => ({
    childrenData: {
      componentName: "Address",
      name: pharmacy.StoreName,
      address_line1: pharmacy["Address|AddressLine1"],
      city: pharmacy["Address|City"],
      state: pharmacy["Address|State"],
      zipCode: pharmacy["Address|ZipCode"],
      distance: pharmacy.distance
    },
    key: "selectedData",
    name: "selectedData",
    type: "listItemWrapper",
    title: pharmacy.StoreName,
    action,
    selectedData: pharmacy,
    childrenType: "pharmacy-address"
  }));
};

class PharmacyMapViewController extends BaseViewController {
  formState = {};

  prepareSubmit(values) {
    return { ...values, ...this.formState };
  }

  handleButtonClick(name, text, action) {
    const { values, pickPharmacyOnMap } = this.appData;

    if (name === "pharmacyMap" && values.__viewSelector === "MAP") {
      // marker on map is clicked
      pickPharmacyOnMap(action);
      return;
    }

    if (name === "__manualPharmacy") {
      this.formState = {
        pharmacy_nm: "",
        "phone_faxes.0.phone_number": "",
        "phone_faxes.0.extension": "",
        "addresses.0.address_line1": "",
        "addresses.0.address_line2": "",
        "addresses.0.city": "",
        "addresses.0.state_province": "",
        "addresses.0.postal": "",
        twenty_four_hour_flg: "N"
      };
    } else {
      this.formState = {
        selectedData: { ...text },
        erx_vendor_id: text.erx_vendor_id,
        erx_vendor_code: text.erx_vendor_code,
        pharmacy_view: buildPharmacyViewString(text)
      };
    }

    if (this.screen.action.value === "/pharmacy_new") {
      getFlow({
        url: this.screen.action.value,
        formState: this.prepareSubmit(this.appData.values)
      }).then(() => {
        super.handleButtonClick(
          name,
          {},
          {
            type: "url",
            value: "/screens/pharmacies"
          },
          3
        );
      });
    } else {
      super.handleButtonClick(name, text, action);
    }
  }

  preprocessScreenData() {
    const {
      values: { __viewSelector },
      pharmacies,
      settings
    } = this.appData;

    buildPharmacyStatusMessage(this.screen, pharmacies, settings);

    if (__viewSelector === "MAP") {
      this.screen = {
        ...this.screen,
        fields: [
          ...this.screen.fields,
          ...buildPharmacies(
            pharmacies.selected ? [pharmacies.selected] : [],
            this.screen.action,
            this.components
          )
        ]
      };
    }
  }
}

PharmacyMapViewController.fieldValidation = pharmacyValidation;

export default PharmacyMapViewController;
